import { Outlet } from 'react-router-dom';
import { SideBarRight } from '../SideBarRight/SideBarRight';
import { SideBarLeft } from '../SideBarLeft/SideBarLeft';
import './LayoutHorizontal.css';
import { Dispatch, SetStateAction } from 'react';
import { Footer } from '../Footer/Footer';

export const LayoutHorizontal = ({
    isInventoryOpen,
    setIsInventoryOpen,
}: {
    isInventoryOpen: boolean;
    setIsInventoryOpen: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <section className="layout-horizontal">
            <SideBarLeft />

            <main className="layout-horizontal__main">
                {/*TODO вынести title в компоненты*/}
                {/*<Title />*/}
                <Outlet />
            </main>

            <SideBarRight isInventoryOpen={isInventoryOpen} setIsInventoryOpen={setIsInventoryOpen} />
        </section>
    );
};
